import AppConfig from "../../config/config";

/**
 * Single source of truth for a user's avatar storage URL.
 * Callers are responsible for their own load-error fallback.
 */
export function getUserAvatarUrl(userId: string): string {
  return `${AppConfig.supabaseStorageDomain}/storage/v1/object/public/product-images/users/${userId}/profile.jpg`;
}
